import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {DomSanitizer} from "@angular/platform-browser";


@Component({
    selector: 'tutorial-form-dialog',
    templateUrl: './setting-form.component.html',
    styleUrls: ['./setting-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class TutorialFormDialogComponent implements OnInit
{
  action: string;
  dialogTitle;
  public editorContent = ``;
  public editorConfig = {
    placeholder: ""
  };
  title;
  active;
  html;
    constructor(
        public dialogRef: MatDialogRef<TutorialFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any, private satinaizer: DomSanitizer
    )
    {
        this.action = data.action;

        if ( this.action === 'edit' )
        {
            this.dialogTitle = 'tutorial.edit';
            this.title = data.data.title;
            this.active = data.data.active;
            this.editorContent = data.data.html;
        }
      if ( this.action === 'new' )
        {
            this.dialogTitle = 'tutorial.new';
        }
      if ( this.action === 'show' )
      {
        this.dialogTitle =  data.data.title;
        this.html = data.data.html;
      }
    }

    ngOnInit()
    {

    }
}

